import moment from "moment";
import { useState } from "react";
import { BsFillCheckCircleFill } from "react-icons/bs";
import { Button, Table } from "reactstrap";

//local imports
import classes from "@/styles/developers/api/status-main.module.css";
import { apiStatus } from "@/utils/content";

export default function StatusMain() {
  const content = apiStatus.en;

  const [more, setMore] = useState(false);

  return (
    <div className={classes.container}>
      <section className="my-5 py-5 container">
        <h1 className={`text-center ${classes.h1}`}>{content.title}</h1>
      </section>
      <section className="my-5 container">
        <h4 className={`text-center`}>{content.summary}</h4>
        <Table responsive className={classes.table}>
          <thead>
            <tr>
              <td>{content.system}</td>
              <td>{content.currentStatus}</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{content.platformApi}</td>
              <td>
                <BsFillCheckCircleFill size={18} />
                &nbsp;&nbsp;{content.operational}
              </td>
            </tr>
            <tr>
              <td>{content.carrierApi}</td>
              <td>
                <BsFillCheckCircleFill size={18} />
                &nbsp;&nbsp;{content.operational}
              </td>
            </tr>
            <tr>
              <td>{content.webDashboard}</td>
              <td>
                <BsFillCheckCircleFill size={18} />
                &nbsp;&nbsp;{content.operational}
              </td>
            </tr>
            <tr>
              <td>{content.restApi}</td>
              <td>
                <BsFillCheckCircleFill size={18} />
                &nbsp;&nbsp;{content.operational}
              </td>
            </tr>
            <tr>
              <td className={classes.tdGreen}>{content.allSystems}</td>
              <td className={classes.tdGreen}>
                <BsFillCheckCircleFill size={18} />
                &nbsp;&nbsp;{content.operational}
              </td>
            </tr>
          </tbody>
        </Table>
      </section>
      <section className="my-5 container">
        <h3 className={classes.h3}>{content.maintenance}</h3>
        <p>{content.noSchedule}</p>
        <br />
        <h3 className={classes.h3}>{content.pastIncidents}</h3>
        <h5 className={classes.h5}>
          {moment().format("MMMM")} - {content.total}: 0
        </h5>
        <p>{content.noIncidents}</p>
        <h5 className={classes.h5}>
          {moment().subtract(1, "months").format("MMMM")} - {content.total}: 0
        </h5>
        <p>{content.noIncidents}</p>
        <h5 className={classes.h5}>
          {moment().subtract(2, "months").format("MMMM")} - {content.total}: 0
        </h5>
        <p>{content.noIncidents}</p>
        {more && (
          <>
            <h5 className={classes.h5}>
              {moment().subtract(3, "months").format("MMMM")} - {content.total}:
              0
            </h5>
            <p>{content.noIncidents}</p>
            <h5 className={classes.h5}>
              {moment().subtract(4, "months").format("MMMM")} - {content.total}:
              0
            </h5>
            <p>{content.noIncidents}</p>
            <h5 className={classes.h5}>
              {moment().subtract(5, "months").format("MMMM")} - {content.total}:
              0
            </h5>
            <p>{content.noIncidents}</p>
          </>
        )}
        <Button className={classes.btn} onClick={() => setMore(!more)}>
          {more ? content.showless : content.loadmore}
        </Button>
      </section>
    </div>
  );
}
